import {
  useEffect,
  useState
} from 'react';
import {
  Arr
} from '../../../lib/Array.lib';
import Definition from "../../../lib/Definition";
import {
  NOT
} from '../../../lib/GenericTools.lib';
import {
  trim
} from '../../../lib/String.lib';
import formatURL from '../../../lib/tools/formatURL';
import StepHeader from '../../Forms/StepHeader';
import Col from '../../Layout/Wrappers/Col';
import Divider from '../../Layout/Wrappers/Divider';
import Fieldset from '../../Layout/Wrappers/Fieldset';
import IconLinkLauncher from '../../Layout/Wrappers/IconLinkLauncher';
import RadioGroup from '../../Layout/Wrappers/RadioGroup';
import Row from '../../Layout/Wrappers/Row';
import StyledTooltip from '../../Layout/Wrappers/StyledTooltip';
import TextField from '../../Layout/Wrappers/TextField';
import AnswerJobsQuestions from '../../PrescreenQuestions/AnswerJobsQuestions';
import {
  CANDIDATE_UI
} from '../CandidateUI.dic';
import {
  CandidateRolesFieldset
} from '../Forms/CandidateRolesFieldset';
import CandidateSubmissionNotes from '../Forms/CandidateSubmissionNotes';
import {
  EditCandidateRecruiters
} from '../Forms/EditCandidateRecruiters';
import {
  IncludeSubmissionCheckbox
} from '../Forms/IncludeSubmissionCheckbox';
import NoteToAccountManagerFieldset from '../Forms/NoteToAccountManagerFieldset';
import PermitJobsDecision from '../Forms/PermitJobsDecision';
import {
  CANDIDATE_SUMMARY__INCLUDE_FLAGS
} from '../SubmissionNotes.lib';

const CONFIG = {
  name: 'candidate_edit__step_3'
};

export function CandidateEditStep3(props) {
  let { CandidateEditController } = props;
  let { state: candidate, state } = CandidateEditController
  let { account: recruiter } = candidate;

  // following 2 lines are to force compatibility of children class components are using componentDidUpdate
  const [, keepLive] = useState();
  useEffect(() => { keepLive(state.step); }, [state.step]);

  const openStickyNote = event => {
    try {
      if (!event.target.className.match(/ql-editor|ms_button/i)) {
        return console.debug(`element does no match (${event.target.className})`);
      }
      let { top, right, left } = event.target.getBoundingClientRect();
      top = Number(top) - 64;
      left = Number(right) + 32;
      CandidateEditController.StickyNote.open({ top, left })
    } catch (e) { console.debug(e); }
  }

  return (
    <div className='p-1'>

      <StepHeader {...props} />

      {/** 3B1 - reasonsToLeaveLastJob */}
      <Fieldset
        title={CANDIDATE_UI.reasonsToLeaveLastJob.title} dot='orange'
        nextToTitle={
          <StyledTooltip
            title={CANDIDATE_UI.reasonsToLeaveLastJob.tooltip}
            placement='top'
            paperStyle={{ maxWidth: 420 }}
          >
            <i className='material-icons c-purple help icon16'>help_outline</i>
          </StyledTooltip>
        }
        actionBar={
          <IncludeSubmissionCheckbox
            CandidateEditController={CandidateEditController}
            fieldId={CANDIDATE_SUMMARY__INCLUDE_FLAGS.reasonsToLeaveLastJob}
          />
        }
      >
        <TextField
          name="reasonsToLeaveLastJob"
          value={CandidateEditController.state.reasonsToLeaveLastJob}
          onChange={(event) =>
            CandidateEditController.setStateStore({
              reasonsToLeaveLastJob: event.target.value, key: 'reasonsToLeaveLastJob'
            })
          }
          placeholder={CANDIDATE_UI.reasonsToLeaveLastJob.tooltip}
          variant='standard'
          multiline
          fullWidth
        />
      </Fieldset>

      {/** 3B2 - explainRedFlags */}
      <Fieldset
        title={CANDIDATE_UI.explainRedFlags.title} dot='orange'
        info={CANDIDATE_UI.explainRedFlags.tooltip}
        actionBar={
          <IncludeSubmissionCheckbox
            CandidateEditController={CandidateEditController}
            fieldId={CANDIDATE_SUMMARY__INCLUDE_FLAGS.explainRedFlags}
          />
        }
      >
        <TextField
          name="explainRedFlags"
          value={CandidateEditController.state.explainRedFlags}
          onChange={(event) =>
            CandidateEditController.setStateStore({ explainRedFlags: event.target.value, key: 'explainRedFlags' })
          }
          placeholder={CANDIDATE_UI.explainRedFlags.tooltip}
          variant='standard'
          multiline
          fullWidth
        />
      </Fieldset>

      {/** 3BB */}
      {/** [ 2023-01-18 ][ MS: content removed by story_7792 ] */}

      {/** 3C */}
      {/** submissionNotes */}
      <CandidateSubmissionNotes
        candidate={CandidateEditController.state}
        onChange={(submissionNotes) => CandidateEditController.setStateStore({
          submissionNotes,
          key: 'submissionNotes'
        })}
        openStickyNote={openStickyNote}
      />

      {/** 3D */}
      <NoteToAccountManagerFieldset />

      <AnswerJobsQuestions
        name={CONFIG.name}
        reference={self => {
          Object.assign(CandidateEditController, {
            AnswerJobsQuestions: self
          });
          return (AnswerJobsQuestions[CONFIG.name] = self);
        }}
        candidate={candidate}
        jobIds={candidate.jobsPermitted}
        onAcceptLabel='Apply'
        onCancelLabel='Cancel'
        onCancel={update => () => {
          CandidateEditController.setStateStore(update);
        }}
        onChange={CandidateEditController.setStateStore}
      />

      {/** 3E-2 */}
      {/** @todo [ 2023-01-04 ][ TBD ] */}

      <Divider className='mt-3' />
      <CandidateRolesFieldset
        CandidateEditController={CandidateEditController}
      />
      <PermitJobsDecision />

      <Divider className='mt-3' />

      {/** 3E-3 */}
      <EditCandidateRecruiters
        candidate={candidate}
        recruiter={recruiter}
        onSave={update => CandidateEditController.setStateStore({ ...update, key: 'emailsList' })}
        className='mt-3'
        dot
      />

      {/** 3E-4 */}
      {/** HOW DID YOU FIND */}
      <Fieldset
        title='How did you find the candidate?'
        dot='orange'
      >
        <RadioGroup
          name="relationship"
          options={Definition.get("relationShip")}
          value={CandidateEditController.state.relationship}
          onChange={(event, relationship) => {
            CandidateEditController.setStateStore({ relationship, key: 'relationship' });
          }}
        />
      </Fieldset>

      {/** 3E5 */}
      <Row>
        <Fieldset
          title="Candidate's calendar booking link"
          dot='orange'
          nextToTitle={
            <IconLinkLauncher
              url={CandidateEditController.state.calendarBookingLink}
            />
          }
        >
          <TextField
            name="calendarBookingLink"
            value={CandidateEditController.state.calendarBookingLink}
            onChange={(event) => {
              let calendarBookingLink = formatURL(event.target.value);
              const update = {
                calendarBookingLink,
                key: "calendarBookingLink"
              };

              // [2023-12-13][story_9765] "Auto select the checkbox if the recruiter enters a url."
              // IF the NEW calendarBookingLink value IS empty, remove the flag for it from submissionIncludeFlags.
              if (NOT(trim(calendarBookingLink))) {
                update.submissionIncludeFlags = Arr(
                  CandidateEditController.state.submissionIncludeFlags
                ).filter(v => !!v && (v !== CANDIDATE_SUMMARY__INCLUDE_FLAGS.calendarBookingLink));
              }
              // ELSE IF the OLD calendarBookingLink value IS empty, include the flag for it in submissionIncludeFlags.
              else if (NOT(trim(CandidateEditController.state.calendarBookingLink))) {
                update.submissionIncludeFlags = [
                  ...new Set([
                    ...Arr(CandidateEditController.state.submissionIncludeFlags),
                    CANDIDATE_SUMMARY__INCLUDE_FLAGS.calendarBookingLink
                  ])
                ].filter(v => !!v);
              }

              CandidateEditController.setStateStore(update);
            }}
            variant='standard'
            fullWidth
          />
          <IncludeSubmissionCheckbox
            CandidateEditController={CandidateEditController}
            fieldId={CANDIDATE_SUMMARY__INCLUDE_FLAGS.calendarBookingLink}
          />
        </Fieldset>
        <Fieldset
          title='Where else are they interviewing?'
          dot='orange'
        >
          <TextField
            name='otherCompanyInterviews'
            value={CandidateEditController.state.otherCompanyInterviews}
            onChange={(event) =>
              CandidateEditController.setStateStore({
                otherCompanyInterviews: event.target.value,
                key: 'otherCompanyInterviews',
              })
            }
            variant='standard'
            multiline
            rowsMax={5}
            fullWidth
          />
          <IncludeSubmissionCheckbox
            CandidateEditController={CandidateEditController}
            fieldId={CANDIDATE_SUMMARY__INCLUDE_FLAGS.otherCompanyInterviews}
          />
        </Fieldset>
      </Row>

      {/** 3E-6 */}
      {/** HOW SOON */}
      <Row className='mt-3'>
        <Col fullWidth>
          <label>How soon can they start after accepting an offer?</label>
          <RadioGroup
            name="acceptOffer"
            options={
              Definition.get("offerAcceptance")
                .filter(
                  (tag) => (tag.visible !== false)
                )
                .map(
                  (tag) => ({
                    ...tag,
                    onClick: (event) => {
                      if (CandidateEditController.state.acceptOffer === tag.id) {
                        CandidateEditController.setStateStore({
                          acceptOffer: 0,
                          key: 'acceptOffer'
                        });
                      }
                    }
                  })
                )
            }
            value={CandidateEditController.state.acceptOffer}
            onChange={(event, acceptOffer) =>
              CandidateEditController.setStateStore({
                acceptOffer,
                key: 'acceptOffer'
              })
            }
          />
        </Col>
      </Row>

    </div>
  );
}
